
import { Component, Vue } from 'vue-property-decorator'
import ProblemHistoryList from '@/components/templates/ProblemHistoryList.vue'
import { LearningProblemCurriculumUnit } from '@/models/LearningProblemCurriculumUnit'
import { LearningProgress } from '@/const/LearningProgress'
import { CurriculumUnitsApi } from '@/api/methods/CurriculumUnitsApi'
import { GeneralLearningsApi } from '@/api/methods/GeneralLearningsApi'
import { CurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 通常授業サポート学習問題演習履歴一覧
 */
@Component({
  components: {
    ProblemHistoryList,
  },
})
export default class GeneralProblemHistory extends Vue {
  /** 単元情報 */
  private curriculumUnit!: CurriculumUnit

  /** 問題レベル */
  private problemLevel!: string

  /** 通常授業学習問題の演習履歴一覧 */
  private generalProblemHistoryList: LearningProblemCurriculumUnit.ProblemHistory[] = []

  /** 読み込み完了フラグ */
  private isLoaded: boolean = false

  /**
   * 学習履歴ID
   *
   * @returns クエリから取得した学習履歴ID
   */
  private get learningId(): number {
    return Number(this.$route.params.learningId)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()

    // 履歴情報取得
    const responseGeneralLearning = await GeneralLearningsApi.getGeneralLearning(this.learningId)

    // 問題レベル設定
    this.problemLevel = LearningProgress.findByLevel(responseGeneralLearning.level).labelFull

    // 単元情報取得
    const responseCurriculumUnit = await CurriculumUnitsApi.getGeneral(responseGeneralLearning.curriculumUnitId)

    // 単元情報設定
    this.curriculumUnit = { id: responseCurriculumUnit.id, name: responseCurriculumUnit.name }

    // 履歴一覧取得
    const responseHistory = await GeneralLearningsApi.getProblemHistory(this.learningId)

    // 履歴一覧設定
    this.generalProblemHistoryList = responseHistory.map((history) => {
      return {
        learningId: history.id,
        completedDate: new Date(history.completedUnixTime * 1000),
        isCorrect: history.isCorrect,
      }
    })

    // 読み込みフラグ
    this.isLoaded = true

    this.$loading.complete()
  }

  /**
   * 戻るボタン押下時の処理
   */
  private eventClickBackButton(): void {
    // 戻り先情報取得
    const returnPage = this.$prevPage.restorePage()

    // 戻り先情報が存在する場合
    if (returnPage) {
      this.$router.push({
        path: returnPage.path,
        query: returnPage.query,
      })
      return
    }

    this.$router.push(`/student/general/${this.curriculumUnit.id}`)
  }

  /**
   * 履歴クリック時の処理
   *
   * @param learningId 演習履歴ID
   */
  private eventClickHistory(learningId: number): void {
    this.$router.push({
      path: `/student/general/result/${learningId}`,
      query: this.$prevPage.generateQuery(),
    })
  }
}
